import { render, staticRenderFns } from "./partner-say-carousel.vue?vue&type=template&id=5229bdc0&scoped=true"
import script from "./partner-say-carousel.vue?vue&type=script&lang=js"
export * from "./partner-say-carousel.vue?vue&type=script&lang=js"
import style0 from "./partner-say-carousel.vue?vue&type=style&index=0&id=5229bdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229bdc0",
  null
  
)

export default component.exports